var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.352539H20C22.0142 0.352539 23.6475 1.98579 23.6475 4V12C23.6475 14.0142 22.0142 15.6475 20 15.6475H4C1.98579 15.6475 0.352539 14.0142 0.352539 12V4C0.352539 1.98579 1.98579 0.352539 4 0.352539Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.352539H20C22.0142 0.352539 23.6475 1.98579 23.6475 4V12C23.6475 14.0142 22.0142 15.6475 20 15.6475H4C1.98579 15.6475 0.352539 14.0142 0.352539 12V4C0.352539 1.98579 1.98579 0.352539 4 0.352539Z",
    stroke: "#EAECF0",
    strokeWidth: 0.705882
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1484 3C17.8282 3.0002 20 5.14702 20 7.79492C19.9999 10.4427 17.8281 12.5887 15.1484 12.5889C13.9466 12.5889 12.8475 12.1564 12 11.4414C11.1525 12.1563 10.0542 12.5888 8.85254 12.5889C6.17271 12.5889 4.00014 10.4428 4 7.79492C4 5.1469 6.17262 3 8.85254 3C10.0538 3.00003 11.1526 3.43199 12 4.14648C12.8474 3.43183 13.947 3 15.1484 3Z",
    fill: "#ED0006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1475 3C17.8272 3.00021 19.999 5.14703 19.999 7.79492C19.9989 10.4427 17.8271 12.5887 15.1475 12.5889C13.9459 12.5889 12.8475 12.1561 12 11.4414C13.0425 10.562 13.705 9.25548 13.7051 7.79492C13.7051 6.33393 13.043 5.02591 12 4.14648C12.8474 3.43212 13.9463 3 15.1475 3Z",
    fill: "#F9A000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.14648C13.043 5.02591 13.7051 6.33393 13.7051 7.79492C13.705 9.25548 13.0425 10.562 12 11.4414C10.9576 10.562 10.296 9.25535 10.2959 7.79492C10.2959 6.33406 10.9572 5.02591 12 4.14648Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.9c9d5b0a25de27657eb0e936f19ae73a.svg";
export { ForwardRef as ReactComponent };